module.exports = __webpack_public_path__ + "img/advantage-2.49d7efc8.png";